import clsx from 'clsx'
import React from 'react'

import { SkeletonItem } from 'components/reusable/SkeletonItem'

import { UnderlinedTooltip } from '../../../components/ui/UnderlinedTooltip'

interface QuoteDetailsItemProps {
  label: string
  value: string
  variant?: 'default' | 'secondary'
  isLoading?: boolean
  tooltip?: string | React.ReactNode
  discountedValue?: string // If provided, shows strikethrough value with green discounted value
  suffix?: string // Optional suffix to append (e.g. " x 25 employees")
}

export const QuoteDetailsItem = ({
  label,
  value,
  variant = 'default',
  isLoading = false,
  tooltip,
  discountedValue,
  suffix,
}: QuoteDetailsItemProps) => {
  return (
    <div className={clsx('flex items-center w-full')}>
      {tooltip
        ? (
          <UnderlinedTooltip content={tooltip} className='body text-gray-500'>
            {label}
          </UnderlinedTooltip>
          )
        : (
          <span className='body text-gray-500'>{label}</span>
          )}
      <div className='grow shrink-0 min-w-4 border-b border-dotted border-gray-300 mx-2' style={{ height: 0 }} />
      {isLoading
        ? (
          <SkeletonItem widthClass='w-20' heightClass='h-4' />
          )
        : (
          <span
            className={clsx('text-right', {
              'body-bold text-gray-800': variant === 'default',
              'body text-gray-500': variant === 'secondary',
            })}
          >
            {discountedValue
              ? (
                <>
                  <span className='line-through text-gray-500'>{value}</span>
                  {' '}
                  <span className='text-green-400'>{discountedValue}</span>
                  {suffix}
                </>
                )
              : (
                <>
                  {value}
                  {suffix}
                </>
                )}
          </span>
          )}
    </div>
  )
}
